import React from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "../../components/forms/ContactForm";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";

const Discuss = () => {
  const { t } = useTranslation();
  const revealRef = useRevealOnScroll({ threshold: 0.1 });
  return (
    <section
      data-wpr-lazyrender="1"
      className="section-n section--black contact-us-new"
      id="contact-us"
      aria-labelledby="contact-heading"
    >
      <div ref={revealRef} className="container-n reveal">
        <div className="pr-big section__row contact-us-new__layout">
          <a
            className="skip-the-section skip-the-section--custom link-n link-n--white contact-us-new__skip"
            href="#footer"
          >
            <span className="link-n__text">{t("skip.section")}</span>
          </a>

          <div className="contact-us-new__intro">
            <p className="section__subtitle block-title vh-eyebrow vh-eyebrow--on-dark">
              {t("contact.eyebrow")}
            </p>
            <h2
              id="contact-heading"
              className="section__title title-h2 contact-us-new__heading"
            >
              {t("contact.title")}
            </h2>
            <p className="contact-us-new__lede description-n">
              {t("contact.lede")}
            </p>
            <ul className="contact-us-new__bullets" aria-label={t("contact.bulletsAria")}>
              <li>{t("contact.bullet1")}</li>
              <li>{t("contact.bullet2")}</li>
              <li>{t("contact.bullet3")}</li>
            </ul>
          </div>

          <div className="contact-us-new__panel">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Discuss;
